import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import BackToTop from './components/BackToTop';
import Home from './pages/Home';
import Work from './pages/Work';
import WorkDetail from './pages/WorkDetail';
import Contact from './pages/Contact';
import AICreatives from './pages/AICreatives';
import { usePageviewTracker } from './hooks/useAnalytics';

function AnalyticsTracker() {
  usePageviewTracker();
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Work />} />
          <Route path="/portfolio/:id" element={<WorkDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/ai-creatives" element={<AICreatives />} />
        </Routes>
        <Footer />
        <BackToTop />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;